import React from 'react';
import { BiErrorCircle } from 'react-icons/bi';

export const ErrorMessage = ({
  message = '¡Ha ocurrido un error cargando los datos del expediente!',
}) => (
  <div className="flex gap-4 p-4 items-center">
    <div>
      <BiErrorCircle color="orange" size={60} />
    </div>
    <div>
      <h3>{message}</h3>
      <h3>
        Intente nuevamente, si el error persiste contáctenos escribiendo a
        <a href="mailto:soporte-idauto@dox.cl"> soporte-idauto@dox.cl</a>
      </h3>
    </div>
  </div>
);
